module.exports = __webpack_public_path__ + "static/img/right_nor.7906224f.png";